import { ResponsiveRadialBar } from "@nivo/radial-bar";
import { randomIntFromInterval } from "../../../utils/random";
import { getColour } from "../../../utils/colours";

interface radialDataObj {
  x: string;
  y: number;
}

interface radialData {
  id: string;
  data: Array<radialDataObj>;
}

const count1 = randomIntFromInterval(1, 10);
const count2 = randomIntFromInterval(1, 10);

const dummyData = [
  { id: "Profile", data: [{ x: "Profile", y: count1 }] },
  { id: "Average", data: [{ x: "Average", y: count2 }] },
];

export default function RadialChart({
  data,
  className,
  showPlaceholders,
  highlightedColour,
}: {
  data: Array<radialData>;
  className?: string;
  showPlaceholders?: boolean;
  highlightedColour: string;
}) {
  return (
    <div className={className}>
      <ResponsiveRadialBar
        data={showPlaceholders ? dummyData : data}
        valueFormat={(v) => `${v} ${v === 1 ? "minute" : "minutes"}`}
        padding={0.4}
        innerRadius={0.15}
        cornerRadius={8}
        borderWidth={0}
        enableTracks={false}
        margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
        radialAxisStart={
          showPlaceholders
            ? null
            : { tickSize: 0, tickPadding: 10, tickRotation: 0 }
        }
        circularAxisOuter={
          showPlaceholders
            ? null
            : { tickSize: 0, tickPadding: 12, tickRotation: 0 }
        }
        motionConfig="wobbly"
        colors={
          showPlaceholders
            ? getColour("placeholder")
            : ["#CFCFCF", highlightedColour, "#A6A6A4"]
        }
        isInteractive={!showPlaceholders}
        enableRadialGrid={!showPlaceholders}
        enableCircularGrid={!showPlaceholders}
      />
    </div>
  );
}

RadialChart.defaultProps = {
  className: "",
  showPlaceholders: false,
};
